import {Spinner} from 'react-bootstrap';
import Box from '../../styled/Box';
import * as Styled from './SignInPageStyles';
import appConfig from '../../../config/config';
import googleIcon from '../../../images/googleGLogo.svg';
import microsoftLogo from '../../../images/microsoft-logo.svg';
import {H2, Paragraph} from '../../styled/Typography';
import TrovaLogo from '../../components/TrovaLogo/TrovaLogo';

interface LoginBlockProps{
  loading: boolean;
  error?: any;
}

const LoginBlock = ({ loading, error }:LoginBlockProps) => {
  if (loading) {
    return <Spinner animation="border" variant="primary" />
  }

  return (
    <Box width={'100%'} display={'flex'} flexDirection={'column'} alignItems={'center'}>
      <Box mb={5}>
        <Box display={'flex'} justifyContent={'center'} mb={4}>
          <TrovaLogo />
        </Box>
        <H2 color={'primaryBlue'}>Sign in to Trova</H2>
      </Box>
      <Styled.MSigninBtn href={`${appConfig.serverUrlGateway}/google-sso`}>
        <Box maxWidth={200} display={'flex'} justifyItems={'space-between'}>
          <div className="logoContainer">
            <img src={googleIcon} alt="Google"/>
          </div>
          <Styled.StyledSpan>Sign in with Google</Styled.StyledSpan>
        </Box>
      </Styled.MSigninBtn>
      <Styled.MSigninBtn href={`${appConfig.serverUrlGateway}/m-sso`}>
        <Box maxWidth={200} display={'flex'} justifyItems={'space-between'}>
          <div className="logoContainer">
            <img src={microsoftLogo} height={24} width={24} alt="Microsoft"/>
          </div>
          <Styled.StyledSpan>Sign in with Microsoft</Styled.StyledSpan>
        </Box>
      </Styled.MSigninBtn>
      {!!error && (
        <Paragraph mt={2} size={'xs'} color={'triadicRed'}>
          {error}
        </Paragraph>
      )}
    </Box>
  )
}

export default LoginBlock;